import { createSlice } from '@reduxjs/toolkit';

const initialState = () => {
    return {
      user: null,
      authenticationDetails: null,
      authenticationStatus: null,
      authenticatedRoleStatus: null,
      promptNewPasswordStatus: null,
      errors: [],
      generalErrorMessage: null,
      forgotPasswordRequestStatus: null,
      newPasswordStatus: null,
      companyData:{},
      isOpen:true,
      service:null,
      mainItem:null,
      sideBar:null,
      loading:false,

    };
  };

  // Create slice
const authSlice = createSlice({
    name: 'auth',
    initialState: initialState(),
    reducers: {
      setAuthenticatedUser: (state, action) => {
        state.user = action.payload;
      },
      setAuthenticationStatus: (state, action) => {
        state.authenticationStatus = action.payload;
      },
      setAuthenticatedRoleStatus: (state, action) =>{
        state.authenticatedRoleStatus = action.payload;
      },
      setPromptNewPasswordStatus: (state, action) => {
        state.promptNewPasswordStatus = action.payload;
      },
      setAuthenticationDetails: (state, action) => {
        state.authenticationDetails = action.payload;
      },
      setService: (state, action) => {
        state.service= action.payload;
      },
      setSideBar: (state, action) => {
        state.sideBar=action.payload;
      },
      setMainItem: (state, action) => {
        state.mainItem = action.payload;
      },
      setLoading: (state, action) => {
        state.loading = action.payload;
      },
      setGeneralErrorMessage: (state, action) => {
        state.generalErrorMessage = action.payload;
      },
      setErrors: (state, action) => {
        state.errors = action.payload;
      },
      resetAuthData: (state) => {
        const initial = initialState();
        Object.keys(initial).forEach((key) => {
          state[key] = initial[key];
        });
      },
      removeTokenData: (state) => {
        const initial = initialState();
        Object.keys(initial).forEach((key) => {
          if (key === 'authenticationDetails') {
            state[key] = null;
          }
        });
      },
      setForgotPasswordStatus: (state, action) => {
        state.forgotPasswordRequestStatus = action.payload;
      },
      setNewPasswordStatus: (state, action) => {
        state.newPasswordStatus = action.payload;
      },
      setCompanyData: (state, action) => {
        state.companyData = action.payload;
      },
      setIsSideMenuOpen:(state,action)=>{
        state.isOpen=action.payload;
      },
    },
  });
  
  // Export actions, async thunks, and reducer,
  export const {
      setAuthenticatedUser,
      setAuthenticationStatus,
      setAuthenticatedRoleStatus,
      setPromptNewPasswordStatus,
      setAuthenticationDetails,
      setGeneralErrorMessage,
      setService,
      setMainItem,
      setErrors,
      resetAuthData,
      removeTokenData,
      setForgotPasswordStatus,
      setNewPasswordStatus,
      setCompanyData,
      setIsSideMenuOpen,
      setSideBar,
      setLoading,
    } = authSlice.actions;

    
export const auth = authSlice.reducer;